/* Copyright (c) 2023 MOCA Systems, Inc. All rights reserved. */
import dayjs from 'dayjs';

/**
 * A simple timer class that can be used to measure elapsed time.
 * Usage: timer.init() and then timer.end() to get the elapsed time in milliseconds.
 */
export class Timer {
	private _start?: dayjs.Dayjs;

	public init(): void {
		this._start = dayjs();
	}

	public end(): number | undefined {
		if (!this._start) {
			console.error('Call to end() without calling init() first.');
			return;
		}

		const end = dayjs();
		const elapsedTime = end.diff(this._start);
		return elapsedTime;
	}
}
